'use client';

import React from 'react';

interface ClientsFilterPillsProps {
  selectedFilter: 'ALL' | 'ACTIVE' | 'INACTIVE' | 'NEVER';
  onSelectFilter: (filter: 'ALL' | 'ACTIVE' | 'INACTIVE' | 'NEVER') => void;
  counts: {
    all: number;
    active: number;
    inactive: number;
    never: number;
  };
}

export default function ClientsFilterPills({
  selectedFilter,
  onSelectFilter,
  counts
}: ClientsFilterPillsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 pt-1 pb-1">
      <button
        onClick={() => onSelectFilter('ALL')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition cursor-pointer ${
          selectedFilter === 'ALL'
            ? 'bg-[#6255F5] text-white shadow-xs'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Todos ({counts.all})
      </button>

      <button
        onClick={() => onSelectFilter('ACTIVE')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition cursor-pointer ${
          selectedFilter === 'ACTIVE'
            ? 'bg-[#6255F5] text-white shadow-xs'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Activos ({counts.active})
      </button>

      <button
        onClick={() => onSelectFilter('INACTIVE')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition cursor-pointer ${
          selectedFilter === 'INACTIVE'
            ? 'bg-[#6255F5] text-white shadow-xs'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Inactivos +90d ({counts.inactive})
      </button>

      <button
        onClick={() => onSelectFilter('NEVER')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition cursor-pointer ${
          selectedFilter === 'NEVER'
            ? 'bg-[#6255F5] text-white shadow-xs'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Sin citas ({counts.never})
      </button>
    </div>
  );
}
